import employeeApi from '../../api/manager/employee'
import router from '../../router'
import {STATUS_TITLE, STATUS_MESSAGE} from '@/utils/notificationMessage'
import Vue from 'vue'

export const state = () => ({
  users: [],
  detailEmployee: {
    password: ''
  },
  totalItems: 0,
  totalPages: 0,
  popup: false,
  editEmployee: {
  },
  showPopup: false,
  errorMessage: {
  },
  listHistoryLogs: ''
})

export const getter = {}

export const mutations = {
  LIST_USER (state, slug) {
    state.users = slug
  },
  DETAIL_EMPLOYEE (state, slug) {
    state.detailEmployee = { ...slug }
    state.editEmployee = { ...slug }
  },
  TOTAL_ITEMS (state, slug) {
    state.totalItems = slug
  },
  TOTAL_PAGE (state, slug) {
    state.totalPages = slug
  },
  CHANGE_EMPLOYEE (state, slug) {
    Object.assign(state.editEmployee, { ...slug })
    if (state.users) {
      const tmpUsers = [...state.users]
      const index = tmpUsers.findIndex(u => u.id === slug.id)
      Object.assign(tmpUsers[index], { ...slug })
      state.users = tmpUsers
    }
  },
  CHANGE_MESSAGE_ERROR (state, slug) {
    state.errorMessage = { ...slug }
  },
  LOG_HISTORY (state, slug) {
    state.listHistoryLogs = { ...slug }
  }
}

export const actions = {
  async listEmployee ({commit}, params) {
    try {
      const res = await employeeApi.getList(params)
      if (res.status === 200) {
        commit('LIST_USER', res.data.data)
        commit('TOTAL_ITEMS', res.data.metadata.total_items)
        commit('TOTAL_PAGE', res.data.metadata.total_pages)
      }
    } catch (error) {

    }
  },
  async detailEmployee ({commit}, params) {
    try {
      const res = await employeeApi.getDetail(params)
      if (res.status === 200) {
        res.data.data.password = ''
        commit('DETAIL_EMPLOYEE', res.data.data)
      }
    } catch (error) {

    }
  },
  async deleteEmployee ({commit}, params) {
    const vm = new Vue()
    try {
      const res = await employeeApi.delete(params)
      if (res.status === 204) {
        vm.notify('success', {title: STATUS_TITLE.SUCCESS, message: STATUS_MESSAGE.DELETED})
        const resList = await employeeApi.getList({page_index: 1})
        if (resList.status === 200) {
          commit('LIST_USER', resList.data.data)
          commit('TOTAL_ITEMS', resList.data.metadata.total_items)
          commit('TOTAL_PAGE', resList.data.metadata.total_pages)
        }
        router.push('/manager/employees')
      }
    } catch (error) {

    }
  },
  async editEmployee ({commit}, params) {
    const vm = new Vue()
    try {
      const res = await employeeApi.edit(params)
      if (res.status === 201) {
        commit('CHANGE_EMPLOYEE', res.data.data)
        vm.$toastr.s(STATUS_MESSAGE.UPDATED)
        params.modal.hide()
      }
    } catch (error) {
      vm.$toastr.e(error.response.data.error)
      commit('CHANGE_MESSAGE_ERROR', error.response.data.error)
    }
  },
  async addEmployee ({commit}, params) {
    const vm = new Vue()
    try {
      const res = await employeeApi.add(params.formData)
      if (res.status === 201) {
        params.clearParams()
        commit('CHANGE_MESSAGE_ERROR', '')
        params.modal.hide()
        vm.$toastr.s('正常に追加されました！')
        const resList = await employeeApi.getList({page_index: 1})
        if (resList.status === 200) {
          commit('LIST_USER', resList.data.data)
          commit('TOTAL_ITEMS', resList.data.metadata.total_items)
          commit('TOTAL_PAGE', resList.data.metadata.total_pages)
        }
      }
    } catch (error) {
      vm.$toastr.e(error.response.data.error)
      commit('CHANGE_MESSAGE_ERROR', error.response.data.error)
    }
  },
  async getListHistory ({commit}, params) {
    try {
      const res = await employeeApi.getHisitoryLogs(params)
      commit('LOG_HISTORY', res.data.data)
    } catch (e) {

    }
  },
  async archiveEmployee ({commit}, id) {
    try {
      const res = await employeeApi.archiveEmployee(id)
      commit('LOG_HISTORY', res.data.data)
    } catch (e) {

    }
  },
  async unArchiveEmployee ({commit}, id) {
    try {
      const res = await employeeApi.unArchiveEmployee(id)
      commit('LOG_HISTORY', res.data.data)
    } catch (e) {

    }
  }
}

export default {
  namespaced: true,
  state,
  getter,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/manager/employee.js